import { render } from "./OutOfProduction.vue?vue&type=template&id=4f98a74c&ts=true"
import script from "./OutOfProduction.vue?vue&type=script&lang=ts"
export * from "./OutOfProduction.vue?vue&type=script&lang=ts"

import "./OutOfProduction.vue?vue&type=style&index=0&id=4f98a74c&lang=css"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__